import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  Form,
  Modal,
  Select,
  DatePicker,
  InputNumber,
  Tag,
  message,
  Dropdown,
  Menu,
  Divider,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
  getLemburList,
  createLembur,
  updateLembur,
  deleteLembur,
} from "../../api/transaksi/Lembur";
import { dropdownKaryawan } from "../../api/master/Karyawan";
const { Option } = Select;

export default function Lembur() {
  const [form] = Form.useForm();
  const [formLunas] = Form.useForm();
  const [data, setData] = useState();
  const [listKaryawan, setListKaryawan] = useState([]);
  const [editingRecord, setEditingRecord] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoadingTabel, setIsLoadingTabel] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [showTanggalDibayar, setShowTanggalDibayar] = useState(false);

  const sessiData = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    fetchKaryawan();
    fetchData();
  }, []);

  useEffect(() => {
    const statusPembayaran = form.getFieldValue("ovt_status_pembayaran");
    setShowTanggalDibayar(statusPembayaran === "lunas");
  }, [modalVisible]);

  const handleAdd = () => {
    setEditingRecord(null);
    form.resetFields();
    form.setFieldsValue({
      ovt_status: "pending",
      ovt_status_pembayaran: "pending",
    });
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    if (
      record.ovt_status === "disetujui" &&
      record.ovt_status_pembayaran === "lunas"
    ) {
      message.warning(
        "Data ini tidak dapat diedit karena sudah disetujui dan lunas."
      );
      return;
    }
    setEditingRecord(record);
    form.setFieldsValue({
      ...record,
      ovt_tanggal_lembur: record.ovt_tanggal_lembur
        ? dayjs(record.ovt_tanggal_lembur)
        : null,
      ovt_tanggal_dibayar: dayjs(record.ovt_tanggal_dibayar).isValid()
        ? dayjs(record.ovt_tanggal_dibayar)
        : null,
    });
    setModalVisible(true);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = data.filter((item) =>
      item.karyawan.emp_nama.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Nama Karyawan",
      dataIndex: "nama_karyawan",
      key: "nama_karyawan",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Cari nama"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={confirm}
              size="small"
            >
              Cari
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) =>
        record.nama_karyawan?.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Tanggal Lembur",
      dataIndex: "ovt_tanggal_lembur",
      sorter: (a, b) =>
        dayjs(a.ovt_tanggal_lembur).unix() - dayjs(b.ovt_tanggal_lembur).unix(),
      sortDirections: ["descend", "ascend"],
      render: (value) => {
        const date = dayjs(value);
        return date.isValid() ? date.format("DD/MM/YYYY") : "-";
      },
    },
    {
      title: "Biaya Lembur",
      dataIndex: "ovt_biaya_lembur",
      render: (val) => `${Number(val).toLocaleString("id-ID")}`,
      sorter: (a, b) => a.ovt_biaya_lembur - b.ovt_biaya_lembur,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Keterangan",
      dataIndex: "ovt_keterangan",
    },
    {
      title: "Status Pengajuan",
      dataIndex: "ovt_status",
      filters: [
        { text: "Pending", value: "pending" },
        { text: "Disetujui", value: "disetujui" },
        { text: "Ditolak", value: "ditolak" },
      ],
      onFilter: (value, record) => record.ovt_status === value,
      render: (status) => {
        if (!status || status === "pending")
          return <Tag color="volcano">Pending</Tag>;
        const colorMap = {
          pending: "orange",
          disetujui: "green",
          ditolak: "red",
        };
        return <Tag color={colorMap[status]}>{status.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Status Pembayaran",
      dataIndex: "ovt_status_pembayaran",
      filters: [
        { text: "Tidak Dibayar", value: "tidak dibayar" },
        { text: "Lunas", value: "lunas" },
        { text: "Pending", value: "pending" },
      ],
      onFilter: (value, record) => record.ovt_status_pembayaran === value,
      render: (status) => {
        if (!status || status === "pending")
          return <Tag color="volcano">Pending</Tag>;

        const colorMap = {
          pending: "volcano",
          lunas: "blue",
          "tidak dibayar": "gray",
        };
        const labelMap = {
          pending: "Pending",
          lunas: "Lunas",
          "tidak dibayar": "Tidak Dibayar",
        };

        return (
          <Tag color={colorMap[status]}>{labelMap[status]?.toUpperCase()}</Tag>
        );
      },
    },

    {
      title: "Tanggal Pembayaran",
      dataIndex: "ovt_tanggal_dibayar",
      sorter: (a, b) =>
        dayjs(a.ovt_tanggal_dibayar).unix() -
        dayjs(b.ovt_tanggal_dibayar).unix(),
      sortDirections: ["descend", "ascend"],
      render: (value) => {
        const date = dayjs(value);
        return date.isValid() ? date.format("DD/MM/YYYY") : "-";
      },
    },
    {
      title: "Aksi",
      key: "aksi",
      render: (_, record) => {
        const menu = (
          <Menu>
            {!(
              record.ovt_status === "disetujui" &&
              record.ovt_status_pembayaran === "lunas"
            ) && (
              <Menu.Item key="edit" onClick={() => handleEdit(record)}>
                ✏️ Edit
              </Menu.Item>
            )}

            <Menu.Item
              key="delete"
              danger
              onClick={() => handleDelete(record.ovt_id_lembur)}
            >
              🗑️ Hapus
            </Menu.Item>

            {record.ovt_status === "pending" && (
              <Menu.Item
                key="approve-pengajuan"
                onClick={() => handleApprovePengajuan(record.ovt_id_lembur)}
              >
                ✅ Konfirmasi Pengajuan
              </Menu.Item>
            )}

            {record.ovt_status === "disetujui" &&
              record.ovt_status_pembayaran === "pending" && (
                <Menu.Item
                  key="approve-pembayaran"
                  onClick={() => handleApprovePembayaran(record.ovt_id_lembur)}
                >
                  💰 Konfirmasi Pembayaran
                </Menu.Item>
              )}

            {(record.ovt_status === "pending" ||
              record.ovt_status === "disetujui") &&
              record.ovt_status_pembayaran === "pending" && (
                <Menu.Item
                  key="approve-all"
                  onClick={() => handleApproveBoth(record.ovt_id_lembur)}
                >
                  ✅💰 Setujui & Tandai Lunas
                </Menu.Item>
              )}
          </Menu>
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  const handleApprovePengajuan = (id) => {
    Modal.confirm({
      title: "Setujui atau Tolak Pengajuan Lembur?",
      okText: "Setujui",
      cancelText: "Tolak",
      onOk: async () => {
        const payload = {
          ovt_status: "disetujui",
          ovt_update_by: sessiData[0].user[0].fullname,
        };

        const res = await updateLembur(id, payload);
        res
          ? message.success("Pengajuan disetujui.")
          : message.error(res.message);
        fetchData();
      },
      onCancel: async () => {
        const payload = {
          ovt_status: "ditolak",
          ovt_status_pembayaran: "tidak dibayar",
          ovt_update_by: sessiData[0].user[0].fullname,
        };

        const res = await updateLembur(id, payload);
        res
          ? message.success("Pengajuan ditolak.")
          : message.error(res.message);
        fetchData();
      },
    });
  };

  const handleApprovePembayaran = (id) => {
    Modal.info({
      title: "Pilih status pembayaran lembur:",
      content: (
        <div style={{ marginTop: 20 }}>
          <Button
            type="primary"
            onClick={() => {
              Modal.destroyAll();
              showInputLunasForm(id);
            }}
            style={{ marginRight: 10 }}
          >
            Lunas
          </Button>
          <Button
            danger
            onClick={async () => {
              Modal.destroyAll();
              const payload = {
                ovt_status_pembayaran: "tidak dibayar",
                ovt_biaya_lembur: null,
                ovt_tanggal_dibayar: null,
                ovt_update_by: sessiData[0].user[0].fullname,
              };
              const res = await updateLembur(id, payload);
              res
                ? message.success("Ditandai sebagai tidak dibayar.")
                : message.error(res.message);
              fetchData();
            }}
          >
            Tidak Dibayar
          </Button>
        </div>
      ),
      okButtonProps: { style: { display: "none" } },
      closable: true,
    });
  };

  const showInputLunasForm = (id) => {
    const currentRecord = data.find((item) => item.ovt_id_lembur === id);
    formLunas.setFieldsValue({
      ovt_biaya_lembur: currentRecord?.ovt_biaya_lembur || null,
      ovt_tanggal_dibayar: null,
    });

    Modal.confirm({
      title: "Input Pembayaran Lembur",
      icon: null,
      content: (
        <Form form={formLunas} layout="vertical" id="form-modal-lunas">
          <Form.Item
            label="Biaya Lembur"
            name="ovt_biaya_lembur"
            rules={[
              { required: true, message: "Biaya lembur tidak boleh kosong." },
            ]}
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
              }
              parser={(value) => value.replace(/Rp\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Form.Item
            label="Tanggal Dibayar"
            name="ovt_tanggal_dibayar"
            rules={[
              { required: true, message: "Tanggal dibayar harus dipilih." },
            ]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </Form>
      ),
      okText: "Simpan",
      onOk: async () => {
        try {
          const values = await formLunas.validateFields();

          const payload = {
            ovt_status: "disetujui",
            ovt_status_pembayaran: "lunas",
            ovt_biaya_lembur: values.ovt_biaya_lembur,
            ovt_tanggal_dibayar:
              values.ovt_tanggal_dibayar.format("YYYY-MM-DD"),
            ovt_update_by: sessiData[0].user[0].fullname,
          };

          const res = await updateLembur(id, payload);
          if (res) {
            message.success("Status pembayaran berhasil diperbarui.");
            fetchData();
            formLunas.resetFields();
          } else {
            message.error(res.message);
            return Promise.reject(new Error(res.message));
          }
        } catch (err) {
          console.log(err);
          message.error("Lengkapi semua input sebelum menyimpan.");
          return Promise.reject(
            new Error("Lengkapi semua input sebelum menyimpan.")
          );
        }
      },
      afterClose() {
        formLunas.resetFields();
      },
    });
  };

  const handleApproveBoth = (id) => {
    showInputLunasForm(id);
  };

  const fetchData = async () => {
    setIsLoadingTabel(true);
    try {
      const result = await getLemburList();
      if (result.status) {
        setData(result.data);
      } else {
        setData([]);
        message.error("Data tidak ditemukan.!");
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Terjadi kesalahan saat mengambil data";
      message.error(errorMessage);
      setData([]);
    } finally {
      setIsLoadingTabel(false);
    }
  };

  const fetchKaryawan = async () => {
    try {
      const result = await dropdownKaryawan();
      setListKaryawan(result.data);
    } catch (error) {
      message.error("Gagal memuat data karyawan.");
    }
  };

  const handleFinish = async (values) => {
    setIsLoadingSubmit(true);
    try {
      if (values.ovt_status === "ditolak") {
        values.ovt_status_pembayaran = "tidak dibayar";
      }

      const payload = {
        ...values,
        ovt_tanggal_lembur: values.ovt_tanggal_lembur.format("YYYY-MM-DD"),
        ...(values.ovt_tanggal_dibayar && {
          ovt_tanggal_dibayar: values.ovt_tanggal_dibayar.format("YYYY-MM-DD"),
        }),
        [editingRecord ? "ovt_updated_by" : "ovt_created_by"]:
          sessiData[0].user[0].fullname,
      };

      if (editingRecord) {
        await updateLembur(editingRecord.ovt_id_lembur, payload);
        message.success("Data lembur berhasil diperbarui.");
      } else {
        await createLembur(payload);
        message.success("Data lembur berhasil ditambahkan.");
      }

      fetchData();
      setModalVisible(false);
      form.resetFields();
    } catch (err) {
      console.log(err);
      message.error("Terjadi kesalahan saat menyimpan data.");
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Apakah Anda yakin ingin menghapus data lembur ini?",
      content: "Tindakan ini tidak dapat dibatalkan.",
      okText: "Hapus",
      okType: "danger",
      cancelText: "Batal",
      onOk: async () => {
        setIsLoadingSubmit(true);
        try {
          const res = await deleteLembur(id);
          res
            ? message.success("Data lembur berhasil dihapus.")
            : message.error(res.message);
          fetchData();
        } catch {
          message.error("Gagal menghapus data lembur.");
        } finally {
          setIsLoadingSubmit(false);
        }
      },
    });
  };

  return (
    <div>
      <Divider>Input Lembur Karyawan</Divider>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAdd}
        style={{ marginBottom: 16 }}
        loading={isLoadingSubmit}
      >
        Buat Lembur Baru
      </Button>
      <Table
        loading={isLoadingTabel}
        columns={columns}
        pagination={{
          pageSizeOptions: ["10", "20", "40", "60"],
          showSizeChanger: true,
          defaultPageSize: 20,
        }}
        dataSource={searchText ? filteredData : data}
        rowKey="ovt_id_lembur"
      />

      <Modal
        title={editingRecord ? "Edit Lembur" : "Tambah Lembur"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          onValuesChange={(changedValues) => {
            if (changedValues.ovt_status_pembayaran !== undefined) {
              setShowTanggalDibayar(
                changedValues.ovt_status_pembayaran === "lunas"
              );
            }
          }}
        >
          <Form.Item
            label="Nama Karyawan"
            name="ovt_id_karyawan"
            rules={[{ required: true, message: "Pilih nama karyawan" }]}
          >
            <Select placeholder="Pilih karyawan">
              {listKaryawan.map((emp) => (
                <Option key={emp.emp_id_karyawan} value={emp.emp_id_karyawan}>
                  {emp.emp_nama}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Tanggal Lembur"
            name="ovt_tanggal_lembur"
            rules={[{ required: true, message: "Pilih tanggal lembur" }]}
          >
            <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Biaya Lembur"
            name="ovt_biaya_lembur"
            rules={[{ required: true, message: "Masukkan biaya lembur" }]}
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
              }
              parser={(value) => value.replace(/Rp\s?|(,*)/g, "")}
            />
          </Form.Item>
          <Form.Item
            label="Keterangan"
            name="ovt_keterangan"
            rules={[{ required: true, message: "Masukkan keterangan" }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="Status Pengajuan"
            name="ovt_status"
            rules={[{ required: true, message: "Pilih status pengajuan" }]}
          >
            <Select>
              <Option value="pending">Pending</Option>
              <Option value="disetujui">Disetujui</Option>
              <Option value="ditolak">Ditolak</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Status Pembayaran"
            name="ovt_status_pembayaran"
            rules={[{ required: true, message: "Pilih status pembayaran" }]}
          >
            <Select>
              <Option value="pending">Pending</Option>
              <Option value="lunas">Lunas</Option>
              <Option value="tidak dibayar">Tidak Dibayar</Option>
            </Select>
          </Form.Item>

          {showTanggalDibayar && (
            <Form.Item
              label="Tanggal Dibayar"
              name="ovt_tanggal_dibayar"
              rules={[{ required: true, message: "Pilih tanggal dibayar" }]}
            >
              <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </div>
  );
}
